import React from 'react';
import PropTypes from 'prop-types';
import { Input, Select, Button, Form, Icon } from 'antd';
import { debounce } from 'lodash';

export const filterCareerCoachReport = (props, changedValues, values) => {
  const { responses, onSearch, setSettings } = props;

  const norm = v => (v == null ? '' : String(v).trim());
  const up = v => norm(v).toUpperCase();
  const any = arr => Array.isArray(arr) && arr.length > 0;
  const inList = (val, list) => !any(list) || list.some(x => norm(x) === norm(val));

  const coacheeTerm = up(values.coacheeSearchTerm);
  const TMPractices = values.selectedTMPractices;
  const TMMajors = values.selectedTMMajors;
  const TMPositions = values.selectedTMPositions;
  const TMOffices = values.selectedTMOffices;

  const coachTerm = up(values.coachSearchTerm);
  const CCPractices = values.selectedCCPractices;
  const CCMajors = values.selectedCCMajors;
  const CCPositions = values.selectedCCPositions;
  const CCOffices = values.selectedCCOffices;

  setSettings({

    tmSearch: values.coacheeSearchTerm,
    tmPractice: TMPractices,
    tmMajor: TMMajors,
    tmPosition: TMPositions,
    tmOffice: TMOffices,
    ccSearch: values.coachSearchTerm,
    ccPractice: CCPractices,
    ccMajor: CCMajors,
    ccPosition: CCPositions,
    ccOffice: CCOffices
  });

  const filteredResponses = responses.filter(r => {
    const tmName = up(r.tmName);
    const tmPractice = norm(r.tmPractice);
    const tmMajor = norm(r.tmMajor);
    const tmPosition = norm(r.tmPosition);
    const tmOffice = norm(r.tmOffice);

    const ccName = up(r.ccName);
    const ccPractice = norm(r.ccPractice);
    const ccMajor = norm(r.ccMajor);
    const ccPosition = norm(r.ccPosition);
    const ccOffice = norm(r.ccOffice);
    const isCoacheeValid = !coacheeTerm || tmName.includes(coacheeTerm);
    const isCcValid = !coachTerm || ccName.includes(coachTerm);
    const isTMPracticeValid = inList(tmPractice, TMPractices);
    const isTMMajorValid = inList(tmMajor, TMMajors);
    const isTMPositionValid = inList(tmPosition, TMPositions);
    const isTMOfficeValid = inList(tmOffice, TMOffices);

    const isCCPracticeValid = inList(ccPractice, CCPractices);
    const isCCMajorValid = inList(ccMajor, CCMajors);
    const isCCPositionValid = inList(ccPosition, CCPositions);
    const isCCOfficeValid = inList(ccOffice, CCOffices);

    return (
      isCoacheeValid &&
      isTMPracticeValid &&
      isTMMajorValid &&
      isTMPositionValid &&
      isTMOfficeValid &&
      isCcValid &&
      isCCPracticeValid &&
      isCCMajorValid &&
      isCCPositionValid &&
      isCCOfficeValid
    );
  });

  onSearch(filteredResponses);
};


const CareerCoachReportFilters = props => {
  const { responses = [], form, settings, searchRef, disabled } = props;
  const empls = responses;
  const practices = [...new Set(empls.map(e => e.tmPractice).filter(Boolean))].sort();

  const majors = [...new Set(empls.map(e => e.tmMajor).filter(Boolean))].sort();
  const positions = [...new Set(empls.map(e => e.tmPosition).filter(Boolean))].sort();
  const offices = [...new Set(empls.map(e => e.tmOffice).filter(Boolean))].sort();

  const { getFieldDecorator } = form;

  const selectedTMPractices = form.getFieldValue('selectedTMPractices') || [];
  const selectedTMMajors = form.getFieldValue('selectedTMMajors') || [];
  const selectedTMPositions = form.getFieldValue('selectedTMPositions') || [];
  const selectedTMOffices = form.getFieldValue('selectedTMOffices') || [];

  const selectedCCPractices = form.getFieldValue('selectedCCPractices') || [];
  const selectedCCMajors = form.getFieldValue('selectedCCMajors') || [];
  const selectedCCPositions = form.getFieldValue('selectedCCPositions') || [];
  const selectedCCOffices = form.getFieldValue('selectedCCOffices') || [];

  const clearFilters = () => {
    form.resetFields();
    filterCareerCoachReport(
      props,
      {},
      {
        coacheeSearchTerm: '',
        selectedTMPractices: [],
        selectedTMMajors: [],
        selectedTMPositions: [],
        selectedTMOffices: [],
        coachSearchTerm: '',
        selectedCCPractices: [],
        selectedCCMajors: [],
        selectedCCPositions: [],
        selectedCCOffices: []
      }
    );
  };

  return (
    <div style={disabled ? { pointerEvents: 'none', opacity: 0.4 } : {}}>
      <Form layout="inline">
        <Form.Item>
          {getFieldDecorator('coacheeSearchTerm', {
            initialValue: settings.tmSearch
          })(
            <Input
              prefix={<Icon type="filter"/>}
              ref={searchRef}
              disabled={disabled}
              placeholder="Filter by Team Member"
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('selectedTMPractices', {
            initialValue: settings.tmPractice
          })(
            <Select
              maxTagCount={0}
              maxTagPlaceholder={`${selectedTMPractices.length} Practice${
                selectedTMPractices.length === 1 ? '' : 's'
              } Selected`}
              showArrow
              mode="multiple"
              placeholder="TM Practice"
              dropdownClassName="filter-bar-select-dropdown"
              className="filter-bar-select"
            >
              {practices.map(p => (
                <Select.Option key={p} value={p}>
                  {p}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('selectedTMMajors', {
            initialValue: settings.tmMajor
          })(
            <Select
              maxTagCount={0}
              maxTagPlaceholder={`${selectedTMMajors.length} ${
                selectedTMMajors.length === 1 ? 'Major' : 'Majors'
              } Selected`}
              showArrow
              mode="multiple"
              placeholder="TM Major"
              dropdownClassName="filter-bar-select-dropdown"
              className="filter-bar-select"
            >
              {majors.map(p => (
                <Select.Option key={p} value={p}>
                  {p}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('selectedTMPositions', {
            initialValue: settings.tmPosition
          })(
            <Select
              maxTagCount={0}
              maxTagPlaceholder={`${selectedTMPositions.length} Position${
                selectedTMPositions.length === 1 ? '' : 's'
              } Selected`}
              showArrow
              mode="multiple"
              placeholder="TM Position"
              dropdownClassName="filter-bar-select-dropdown"
              className="filter-bar-select"
            >
              {positions.map(p => (
                <Select.Option key={p} value={p}>
                  {p}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('selectedTMOffices', {
            initialValue: settings.tmOffice
          })(
            <Select
              maxTagCount={0}
              maxTagPlaceholder={`${selectedTMOffices.length} Office${
                selectedTMOffices.length === 1 ? '' : 's'
              } Selected`}
              showArrow
              mode="multiple"
              placeholder="TM Office"
              dropdownClassName="filter-bar-select-dropdown"
              className="filter-bar-select"
            >
              {offices.map(o => (
                <Select.Option key={o} value={o}>
                  {o}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>

        <Form.Item>
          {getFieldDecorator('coachSearchTerm', {
            initialValue: settings.ccSearch
          })(<Input prefix={<Icon type="filter"/>} disabled={disabled} placeholder="Filter by Career Coach"/>)}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('selectedCCPractices', {
            initialValue: settings.ccPractice
          })(
            <Select
              maxTagCount={0}
              maxTagPlaceholder={`${selectedCCPractices.length} Practice${
                selectedCCPractices.length === 1 ? '' : 's'
              } Selected`}
              showArrow
              mode="multiple"
              placeholder="CC Practice"
              dropdownClassName="filter-bar-select-dropdown"
              className="filter-bar-select"
            >
              {practices.map(p => (
                <Select.Option key={p} value={p}>
                  {p}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('selectedCCMajors', {
            initialValue: settings.ccMajor
          })(
            <Select
              maxTagCount={0}
              maxTagPlaceholder={`${selectedCCMajors.length} ${
                selectedCCMajors.length === 1 ? 'Major' : 'Majors'
              } Selected`}
              showArrow
              mode="multiple"
              placeholder="CC Major"
              dropdownClassName="filter-bar-select-dropdown"
              className="filter-bar-select"
            >
              {majors.map(p => (
                <Select.Option key={p} value={p}>
                  {p}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('selectedCCPositions', {
            initialValue: settings.ccPosition
          })(
            <Select
              maxTagCount={0}
              maxTagPlaceholder={`${selectedCCPositions.length} Position${
                selectedCCPositions.length === 1 ? '' : 's'
              } Selected`}
              showArrow
              mode="multiple"
              placeholder="CC Position"
              dropdownClassName="filter-bar-select-dropdown"
              className="filter-bar-select"
            >
              {positions.map(p => (
                <Select.Option key={p} value={p}>
                  {p}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('selectedCCOffices', {
            initialValue: settings.ccOffice
          })(
            <Select
              maxTagCount={0}
              maxTagPlaceholder={`${selectedCCOffices.length} Office${
                selectedCCOffices.length === 1 ? '' : 's'
              } Selected`}
              showArrow
              mode="multiple"
              placeholder="CC Office"
              dropdownClassName="filter-bar-select-dropdown"
              className="filter-bar-select"
            >
              {offices.map(o => (
                <Select.Option key={o} value={o}>
                  {o}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Form.Item>
          <Button title="Clear filters" icon="close" type="link" onClick={clearFilters}>
            Clear filters
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

CareerCoachReportFilters.propTypes = {
  onSearch: PropTypes.func.isRequired,
  responses: PropTypes.array
};

export default Form.create({
  name: 'filter_career_coach_report_form',
  onValuesChange: debounce(filterCareerCoachReport, 500)
})(CareerCoachReportFilters);
